import { render, staticRenderFns } from "./CrewBkngDetails.vue?vue&type=template&id=445a17d7&scoped=true&"
import script from "./CrewBkngDetails.vue?vue&type=script&lang=js&"
export * from "./CrewBkngDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445a17d7",
  null
  
)

export default component.exports